
// @ts-nocheck
import locale_en_46json_8bcff391 from "#nuxt-i18n/8bcff391";
import locale_uk_46json_9313e0d1 from "#nuxt-i18n/9313e0d1";
import locale_ru_46json_be150333 from "#nuxt-i18n/be150333";

export const localeCodes =  [
  "en",
  "uk",
  "ru"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_8bcff391",
      load: () => Promise.resolve(locale_en_46json_8bcff391),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_9313e0d1",
      load: () => Promise.resolve(locale_uk_46json_9313e0d1),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_be150333",
      load: () => Promise.resolve(locale_ru_46json_be150333),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/bc479678" /* webpackChunkName: "config_i18n_46config_46ts_bc479678" */)
]

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      iso: "en-US",
      name: "English",
      files: [
        {
          path: "/app/build/products/Survey/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "uk",
      countryCode: "ua",
      iso: "uk-UA",
      name: "Українська",
      files: [
        {
          path: "/app/build/products/Survey/locales/uk.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      iso: "ru-RU",
      name: "Русский",
      files: [
        {
          path: "/app/build/products/Survey/locales/ru.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "bnz_locale",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  messages: {
    en: {
      $vuetify: {
        badge: "Badge",
        open: "Open",
        close: "Close",
        dismiss: "Dismiss",
        confirmEdit: {
          ok: "OK",
          cancel: "Cancel"
        },
        dataIterator: {
          noResultsText: "No matching records found",
          loadingText: "Loading items..."
        },
        dataTable: {
          itemsPerPageText: "Rows per page:",
          ariaLabel: {
            sortDescending: "Sorted descending.",
            sortAscending: "Sorted ascending.",
            sortNone: "Not sorted.",
            activateNone: "Activate to remove sorting.",
            activateDescending: "Activate to sort descending.",
            activateAscending: "Activate to sort ascending."
          },
          sortBy: "Sort by"
        },
        dataFooter: {
          itemsPerPageText: "Items per page:",
          itemsPerPageAll: "All",
          nextPage: "Next page",
          prevPage: "Previous page",
          firstPage: "First page",
          lastPage: "Last page",
          pageText: "{0}-{1} of {2}"
        },
        dateRangeInput: {
          divider: "to"
        },
        datePicker: {
          itemsSelected: "{0} selected",
          range: {
            title: "Select dates",
            header: "Enter dates"
          },
          title: "Select date",
          header: "Enter date",
          input: {
            placeholder: "Enter date"
          },
          ariaLabel: {
            previousMonth: "Previous month",
            nextMonth: "Next month",
            selectYear: "Select year",
            selectDate: "{0}",
            currentDate: "Today, {0}"
          }
        },
        noDataText: "No data available",
        carousel: {
          prev: "Previous visual",
          next: "Next visual",
          ariaLabel: {
            delimiter: "Carousel slide {0} of {1}"
          }
        },
        calendar: {
          moreEvents: "{0} more",
          today: "Today"
        },
        input: {
          clear: "Clear {0}",
          prependAction: "{0} prepended action",
          appendAction: "{0} appended action",
          otp: "Please enter OTP character {0}"
        },
        fileInput: {
          counter: "{0} files",
          counterSize: "{0} files ({1} in total)"
        },
        fileUpload: {
          title: "Drag and drop files here",
          divider: "or",
          browse: "Browse Files"
        },
        timePicker: {
          am: "AM",
          pm: "PM",
          title: "Select Time"
        },
        pagination: {
          ariaLabel: {
            root: "Pagination Navigation",
            next: "Next page",
            previous: "Previous page",
            page: "Go to page {0}",
            currentPage: "Page {0}, Current page",
            first: "First page",
            last: "Last page"
          }
        },
        stepper: {
          next: "Next",
          prev: "Previous"
        },
        rating: {
          ariaLabel: {
            item: "Rating {0} of {1}"
          }
        },
        loading: "Loading...",
        infiniteScroll: {
          loadMore: "Load more",
          empty: "No more"
        },
        rules: {
          required: "This field is required",
          email: "Please enter a valid email",
          number: "This field can only contain numbers",
          integer: "This field can only contain integer values",
          capital: "This field can only contain uppercase letters",
          maxLength: "You must enter a maximum of {0} characters",
          minLength: "You must enter a minimum of {0} characters",
          strictLength: "The length of the entered field is invalid",
          exclude: "The {0} character is not allowed",
          notEmpty: "Please choose at least one value",
          pattern: "Invalid format"
        },
        hotkey: {
          then: "then",
          ctrl: "Ctrl",
          command: "Command",
          space: "Space",
          shift: "Shift",
          alt: "Alt",
          enter: "Enter",
          escape: "Escape",
          upArrow: "Up Arrow",
          downArrow: "Down Arrow",
          leftArrow: "Left Arrow",
          rightArrow: "Right Arrow",
          backspace: "Backspace",
          option: "Option",
          plus: "plus",
          shortcut: "Keyboard shortcut: {0}"
        },
        video: {
          play: "Play",
          pause: "Pause",
          seek: "Seek",
          volume: "Volume",
          showVolume: "Show volume control",
          mute: "Mute",
          unmute: "Unmute",
          enterFullscreen: "Full screen",
          exitFullscreen: "Exit full screen"
        },
        colorPicker: {
          ariaLabel: {
            eyedropper: "Select color with eyedropper",
            hueSlider: "Hue",
            alphaSlider: "Alpha",
            redInput: "Red value",
            greenInput: "Green value",
            blueInput: "Blue value",
            alphaInput: "Alpha value",
            hueInput: "Hue value",
            saturationInput: "Saturation value",
            lightnessInput: "Lightness value",
            hexInput: "HEX value",
            hexaInput: "HEX with alpha value",
            changeFormat: "Change color format"
          }
        }
      }
    },
    uk: {
      $vuetify: {
        badge: "Значок",
        open: "Відкрити",
        close: "Закрити",
        dismiss: "Відхилити",
        confirmEdit: {
          ok: "ОК",
          cancel: "Скасувати"
        },
        dataIterator: {
          noResultsText: "В результаті пошуку нічого не знайдено",
          loadingText: "Завантаження..."
        },
        dataTable: {
          itemsPerPageText: "Рядків на сторінці:",
          ariaLabel: {
            sortDescending: "Відсортовано за спаданням.",
            sortAscending: "Відсортовано за зростанням.",
            sortNone: "Не відсортовано.",
            activateNone: "Активувати, щоб видалити сортування.",
            activateDescending: "Активувати, щоб відсортувати за спаданням.",
            activateAscending: "Активувати, щоб відсортувати за зростанням."
          },
          sortBy: "Відсортувати за"
        },
        dataFooter: {
          itemsPerPageText: "Елементів на сторінці:",
          itemsPerPageAll: "Всі",
          nextPage: "Наступна сторінка",
          prevPage: "Попередня сторінка",
          firstPage: "Перша сторінка",
          lastPage: "Остання сторінка",
          pageText: "{0}-{1} з {2}"
        },
        dateRangeInput: {
          divider: "до"
        },
        datePicker: {
          itemsSelected: "Вибрано {0}",
          range: {
            title: "Оберіть дати",
            header: "Введіть дати"
          },
          title: "Оберіть дату",
          header: "Введіть дату",
          input: {
            placeholder: "Введіть дату"
          },
          ariaLabel: {
            previousMonth: "Попередній місяць",
            nextMonth: "Наступний місяць",
            selectYear: "Виберіть рік",
            selectDate: "{0}",
            currentDate: "Сьогодні, {0}"
          }
        },
        noDataText: "Немає даних для відображення",
        carousel: {
          prev: "Попередній слайд",
          next: "Наступий слайд",
          ariaLabel: {
            delimiter: "Слайд {0} з {1}"
          }
        },
        calendar: {
          moreEvents: "Ще {0}",
          today: "Сьогодні"
        },
        input: {
          clear: "Очистити {0}",
          prependAction: "{0} попередня дія",
          appendAction: "{0} наступна дія",
          otp: "Будь ласка, введіть символ OTP {0}"
        },
        fileInput: {
          counter: "{0} файлів",
          counterSize: "{0} файлів ({1} загалом)"
        },
        fileUpload: {
          title: "Перетягніть файли сюди",
          divider: "або",
          browse: "Переглянути файли"
        },
        timePicker: {
          am: "AM",
          pm: "PM",
          title: "Оберіть час"
        },
        pagination: {
          ariaLabel: {
            root: "Навігація по сторінках",
            next: "Наступна сторінка",
            previous: "Попередня сторінка",
            page: "Перейти на сторінку {0}",
            currentPage: "Поточна сторінка, Сторінка {0}",
            first: "Перша сторінка",
            last: "Остання сторінка"
          }
        },
        stepper: {
          next: "Далі",
          prev: "Назад"
        },
        rating: {
          ariaLabel: {
            item: "Оцінка {0} з {1}"
          }
        },
        loading: "Завантаження...",
        infiniteScroll: {
          loadMore: "Завантажити більше",
          empty: "Немає більше даних"
        },
        rules: {
          required: "Це поле є обов’язковим",
          email: "Будь ласка, введіть дійсну електронну адресу",
          number: "Це поле може містити лише цифри",
          integer: "Це поле може містити лише цілі числа",
          capital: "Це поле може містити лише великі літери",
          maxLength: "Ви повинні ввести максимум {0} символів",
          minLength: "Ви повинні ввести мінімум {0} символів",
          strictLength: "Довжина введеного поля є недійсною",
          exclude: "Символ {0} не дозволений",
          notEmpty: "Будь ласка, виберіть принаймні одне значення",
          pattern: "Недійсний формат"
        },
        hotkey: {
          then: "потім",
          ctrl: "Ctrl",
          command: "Command",
          shift: "Shift",
          alt: "Alt",
          option: "Option",
          enter: "Enter",
          escape: "Escape",
          upArrow: "Стрілка вгору",
          downArrow: "Стрілка вниз",
          leftArrow: "Стрілка вліво",
          rightArrow: "Стрілка вправо",
          backspace: "Backspace",
          space: "Пробіл",
          plus: "плюс",
          shortcut: "Комбінація клавіш: {0}"
        },
        video: {
          play: "Відтворити",
          pause: "Пауза",
          seek: "Пошук",
          volume: "Гучність",
          showVolume: "Показати регулятор гучності",
          mute: "Вимкнути звук",
          unmute: "Увімкнути звук",
          enterFullscreen: "На весь екран",
          exitFullscreen: "Вийти з повноекранного режиму"
        },
        colorPicker: {
          ariaLabel: {
            eyedropper: "Вибрати колір з екрана",
            hueSlider: "Відтінок",
            alphaSlider: "Прозорість",
            redInput: "Червоний",
            greenInput: "Зелений",
            blueInput: "Синій",
            alphaInput: "Прозорість",
            hueInput: "Відтінок",
            saturationInput: "Насиченість",
            lightnessInput: "Яскравість",
            hexInput: "HEX значення",
            hexaInput: "HEX зі значенням прозорості",
            changeFormat: "Змінити формат кольору"
          }
        }
      }
    },
    ru: {
      $vuetify: {
        badge: "Знак",
        open: "Открыть",
        close: "Закрыть",
        dismiss: "Отклонить",
        confirmEdit: {
          ok: "ОК",
          cancel: "Отмена"
        },
        dataIterator: {
          noResultsText: "Не найдено подходящих записей",
          loadingText: "Запись загружается..."
        },
        dataTable: {
          itemsPerPageText: "Строк на странице:",
          ariaLabel: {
            sortDescending: "Упорядочено по убыванию.",
            sortAscending: "Упорядочено по возрастанию.",
            sortNone: "Не упорядочено.",
            activateNone: "Активируйте, чтобы убрать сортировку.",
            activateDescending: "Активируйте для упорядочивания убыванию.",
            activateAscending: "Активируйте для упорядочивания по возрастанию."
          },
          sortBy: "Сортировать по"
        },
        dataFooter: {
          itemsPerPageText: "Записей на странице:",
          itemsPerPageAll: "Все",
          nextPage: "Следующая страница",
          prevPage: "Предыдущая страница",
          firstPage: "Первая страница",
          lastPage: "Последняя страница",
          pageText: "{0}-{1} из {2}"
        },
        dateRangeInput: {
          divider: "до"
        },
        datePicker: {
          itemsSelected: "{0} выбрано",
          range: {
            title: "Выбранные даты",
            header: "Ввод дат"
          },
          title: "Выбор даты",
          header: "Ввод даты",
          input: {
            placeholder: "Введите дату"
          },
          ariaLabel: {
            previousMonth: "Предыдущий месяц",
            nextMonth: "Следующий месяц",
            selectYear: "Выбрать год",
            selectDate: "{0}",
            currentDate: "Сегодня, {0}"
          }
        },
        noDataText: "Отсутствуют данные",
        carousel: {
          prev: "Предыдущий слайд",
          next: "Следующий слайд",
          ariaLabel: {
            delimiter: "Слайд {0} из {1}"
          }
        },
        calendar: {
          moreEvents: "Еще {0}",
          today: "Сегодня"
        },
        input: {
          clear: "Очистить {0}",
          prependAction: "{0} предварительных действий",
          appendAction: "{0} добавочных действий",
          otp: "Пожалуйста введите символы OTP {0}"
        },
        fileInput: {
          counter: "Файлов: {0}",
          counterSize: "Файлов: {0} (всего {1})"
        },
        fileUpload: {
          title: "Перетащите файлы сюда",
          divider: "или",
          browse: "Просмотр файлов"
        },
        timePicker: {
          am: "AM",
          pm: "PM",
          title: "Выберите время"
        },
        pagination: {
          ariaLabel: {
            root: "Навигация по страницам",
            next: "Следующая страница",
            previous: "Предыдущая страница",
            page: "Перейти на страницу {0}",
            currentPage: "Текущая страница, Страница {0}",
            first: "Первая страница",
            last: "Последняя страница"
          }
        },
        stepper: {
          next: "Следующий",
          prev: "Предыдущий"
        },
        rating: {
          ariaLabel: {
            item: "Рейтинг {0} из {1}"
          }
        },
        loading: "Загрузка...",
        infiniteScroll: {
          loadMore: "Загрузить ещё",
          empty: "Больше нечего загружать"
        },
        rules: {
          required: "Это поле обязательно",
          email: "Пожалуйста, введите действительный email",
          number: "Это поле может содержать только цифры",
          integer: "Это поле может содержать только целые числа",
          capital: "Это поле может содержать только заглавные буквы",
          maxLength: "Вы должны ввести не более {0} символов",
          minLength: "Вы должны ввести не менее {0} символов",
          strictLength: "Длина введенного поля недействительна",
          exclude: "Символ {0} не разрешен",
          notEmpty: "Пожалуйста, выберите хотя бы одно значение",
          pattern: "Недопустимый формат"
        },
        hotkey: {
          then: "затем",
          ctrl: "Ctrl",
          command: "Command",
          shift: "Shift",
          alt: "Alt",
          option: "Option",
          enter: "Enter",
          escape: "Escape",
          upArrow: "Стрелка вверх",
          downArrow: "Стрелка вниз",
          leftArrow: "Стрелка влево",
          rightArrow: "Стрелка вправо",
          backspace: "Backspace",
          space: "Пробел",
          plus: "плюс",
          shortcut: "Сочетание клавиш: {0}"
        },
        video: {
          play: "Воспроизвести",
          pause: "Пауза",
          seek: "Перемотка",
          volume: "Громкость",
          showVolume: "Показать регулятор громкости",
          mute: "Отключить звук",
          unmute: "Включить звук",
          enterFullscreen: "Полноэкранный режим",
          exitFullscreen: "Выйти из полноэкранного режима"
        },
        colorPicker: {
          ariaLabel: {
            eyedropper: "Выбрать цвет с экрана",
            hueSlider: "Оттенок",
            alphaSlider: "Прозрачность",
            redInput: "Красный",
            greenInput: "Зеленый",
            blueInput: "Синий",
            alphaInput: "Прозрачность",
            hueInput: "Оттенок",
            saturationInput: "Насыщенность",
            lightnessInput: "Яркость",
            hexInput: "Значение HEX",
            hexaInput: "Значение HEX с прозрачностью",
            changeFormat: "Изменить формат цвета"
          }
        }
      }
    }
  },
  numberFormats: {
    "en-US": {
      currency: {
        style: "currency",
        currency: "USD"
      }
    }
  },
  pluralRules: {
    uk: function (choice, choicesLength) {
      const n = Math.abs(choice);
      if (choicesLength === 1) {
        return 0;
      }
      if (n % 10 === 1 && n % 100 !== 11) {
        return 0;
      }
      if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
        return 1;
      }
      return 2;
    }
  },
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    name: "English",
    files: [
      {
        path: "/app/build/products/Survey/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "uk",
    countryCode: "ua",
    iso: "uk-UA",
    name: "Українська",
    files: [
      {
        path: "/app/build/products/Survey/locales/uk.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    iso: "ru-RU",
    name: "Русский",
    files: [
      {
        path: "/app/build/products/Survey/locales/ru.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/